<template>
  <div v-show="isLast && hasUnfinishedSession" class="thinking-block">
    <i class="icon-cogitation-line t-iconfont thinking-block__icon"></i>
    <span class="thinking-block__text">{{ text }}</span>
  </div>
</template>

<script setup>
defineOptions({
  name: 'ThinkingBlock'
})

defineProps({
  text: {
    type: String,
    default: ''
  },
  // 是否为本条消息的最后一块，与会话状态共同控制显示。
  isLast: {
    type: Boolean,
    default: false
  },
  hasUnfinishedSession: {
    type: Boolean,
    default: false
  }
})
</script>

<style lang="scss" scoped>
.thinking-block {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 22px;
  color: #969799;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  // user-select: none;

  &__icon {
    flex: none;
    margin-right: 6px;
    font-size: 16px;
    line-height: 16px;
    color: #c9cdd4;
  }

  &__text {
    min-width: 0;
  }
}
</style>
